<template>
  <shared-step-editor-modal
      v-if="loaded"
      :open="open"
      title="Advanced Settings"
      closeText="Cancel"
      confirmText="Save"
      :width="900"
      @confirm="handleConfirm"
      @close="handleClose"
  >
    <div class="shared-modal-edit-piece-advanced-settings">
      <div v-if="titlePiece">
        <label class="control-label">Title</label>
        <input v-model="titlePiece.content" type="text" class="w-full form-control form-input form-input-bordered" />
      </div>
      <step-script-input
          :content="customHeaderContent"
          :instructions="customHeaderInstructions"
          :label-text="'Custom HTML header'"
          :name="'custom_scripts_head'"
          :step-id="step.id"
          @update="customHeaderContent = $event"
      ></step-script-input>
      <step-script-input
          :content="customFooterContent"
          :instructions="customFooterInstructions"
          :label-text="'Custom HTML footer'"
          :name="'custom_scripts_footer'"
          :step-id="step.id"
          @update="customFooterContent = $event"
      ></step-script-input>
      <div>
        <label class="control-label">Form Submission Notifications Settings</label>
        <notifications-emails
            v-if="step"
            :url="'notifications/form-submissions/steps/' + step.id"
            emailable-type="steps"
            :emailable-id="step.id"
            form-submission-notifications-title=""
            form-submission-notifications-description="Whenever a form submission is completed, only the email addresses entered below will be notified."
            no-results-message="Since you have no email addresses entered here, we will use the email addresses set in the notifications section of your account."
        ></notifications-emails>
      </div>
    </div>
  </shared-step-editor-modal>
</template>

<script>
import SharedStepEditorModal from '../../shared/SharedStepEditorModal';
import StepScriptInput from "../../advanced/StepScriptInput.vue";
import NotificationsEmails from "../../../../account/notifications/NotificationsEmails.vue";
import SharedModalInputGroup from "./SharedModalInputGroup.vue";

export default {
  components: {
    SharedModalInputGroup,
    NotificationsEmails,
    StepScriptInput,
    SharedStepEditorModal,
  },
  props: {
    open: Boolean,
    step: Object,
    pieces: Array,
  },
  data: () => ({
    loaded: false,
    customHeaderContent: '',
    customFooterContent: '',
    titlePiece: null,
  }),
  computed: {
    customHeaderPiece() {
      return (this.pieces || []).find(piece => piece.name === 'custom_scripts_head');
    },
    customHeaderInstructions() {
      const {options} = this.customHeaderPiece || {};
      return (
          (options && options.instructions) ||
          'Code entered here will be placed before the closing &lt;/head&gt; tag on this landing page. This is a good spot for scripts like Facebook Pixel or Google Ads Tag. If input is left empty, we will use the value set in the landing pages section of your account.'
      );
    },
    customFooterPiece() {
      return (this.pieces || []).find(piece => piece.name === 'custom_scripts_footer');
    },
    customFooterInstructions() {
      const {options} = this.customFooterPiece || {};
      return (
          (options && options.instructions) ||
          'Code entered here will be placed before the closing &lt;/body&gt; tag on this landing page.  If input is left empty, we will use the value set in the landing pages section of your account.'
      );
    },
  },
  mounted() {
    this.loadTitle();
    this.loadCodeFlask();
  },
  methods: {
    loadCodeFlask() {
      if (window.CodeFlask) {
        this.loaded = true;
      } else {
        $.getScript('https://d281oufm7mm6g9.cloudfront.net/sk/lib/codeflask/1.4.1/codeflask.min.js', () => (this.loaded = true));
      }
    },
    loadTitle() {
      this.pieces.forEach((piece) => {
        if (piece.name === 'Title') {
          this.titlePiece = piece;
        }
      });
    },
    handleConfirm() {
      this.$emit("update", {
        titlePiece: this.titlePiece,
        custom_scripts_head: this.customHeaderContent,
        custom_scripts_footer: this.customFooterContent,
      });
    },
    handleClose() {
      this.$emit("close");
    }
  },
  watch: {
    customHeaderPiece: {
      immediate: true,
      handler(customHeaderPiece) {
        if (customHeaderPiece && !this.customHeaderContent) {
          this.customHeaderContent = customHeaderPiece.content;
        }
      },
    },
    customFooterPiece: {
      immediate: true,
      handler(customFooterPiece) {
        if (customFooterPiece && !this.customFooterContent) {
          this.customFooterContent = customFooterPiece.content;
        }
      },
    },
    pieces: {
      immediate: true,
      handler() {
        this.loadTitle();
      }
    }
  },
}


</script>

<style lang="scss">

.shared-modal-edit-piece-advanced-settings {

  display: flex;
  flex-direction: column;
  gap: 32px;

  .control-label {
    font-weight: bold;
  }
}
</style>
